import { PropsWithChildren, ReactNode } from "react";

import { cn } from "@bentolabs/kit/utils";

type Props = {
  title?: ReactNode;
  className?: string;
};

export const RowGroup = ({
  children,
  title,
  className,
}: PropsWithChildren<Props>) => {
  return (
    <div className={cn("flex flex-col", className)}>
      {title && (
        <h3 className="text-nobel/50 leading-[150%] font-normal capitalize">
          {title}
        </h3>
      )}
      <ul className="mt-2.5 flex flex-col gap-1.5 overflow-hidden rounded-[20px]">
        {children}
      </ul>
    </div>
  );
};
